
module dg.actions {
    export interface IExportStateResolve extends angular.ui.IViewStateResolve {
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        query(...args: any[]): dg.domain.actions.IDomainAction | ng.IPromise<dg.domain.actions.IDomainAction>;
        fileId?: any;
    }

    export class ExportInvokerController extends ActionInvokerController {

        public link: restfulApi.Link;
        public query: dg.domain.queries.ListQuery<dg.domain.IDomainObject>;
        public fileName: string;
        public fileExtension: string;
        public formEditor: dg.objects.FormEditorController;
        public fileId: string;
        private linkQuery: any;

        public constructor(
            $scope: ng.IScope,
            private actionService: dg.actions.ActionService,
            private $q: ng.IQService
        ) {
            super($scope);
        }
        protected binded() {
            return !!this.link;
        }

        protected getTitle() {
            return this.getFileName;
        }

        private get getFileName() {
            return this.fileId ? `${this.fileId} ${this.link.title}` : `${this.link.title}`;
        }

        protected getIcon() {
            return "fa-download";
        }

        protected getInvokeLinks() {
            //HACK:
            let l = { ...this.link };

            l.title = "Download";
            return [l];
        }

        protected executeAction(executionLink: dg.restfulApi.Link): ng.IPromise<any> {

            if (executionLink.rel == dg.restfulApi.DG_LINK_RELS.external) {
                return this.actionService.getExternalExport(executionLink, this.linkQuery);
            }
            else {
                return this.actionService.getQueryExport(executionLink, this.query);
            }
        }

        protected init() {
            this.fileName = this.getFileName;
            this.fileExtension = this.getExt(this.link);

            if (this.link.rel == dg.restfulApi.DG_LINK_RELS.external) {
                this.actionService.getAction(this.link.href).then((query: any) => {
                    this.linkQuery = query;

                    if (query.fileName) {
                        this.fileName = query.fileName;
                    }

                    if (query.fileExtension) {
                        this.fileExtension = '.' + query.fileExtension;
                    }
                });
            }

            this.propTemplateUrl = '/digmo/src/actions/export/export-invoker.html';
        }

        protected executeSucceed(successData) {
            var blobURL = URL.createObjectURL(successData.data);
            //location.href = blobURL;
            var anchor: any = document.createElement("a");
            anchor.download = this.fileName + this.fileExtension;
            anchor.href = blobURL;
            document.body.appendChild(anchor);
            anchor.click();
            // Cleanup the DOM
            document.body.removeChild(anchor);
            // delete anchor;
        }

        getExt = (link: dg.restfulApi.Link) => {
            let ext = ".xlsx";
            if (link.mediaType == 'application/pdf') {
                ext = '.pdf';
            } else if (link.mediaType == 'application/zip') {
                ext = '.zip';
            } else if (link.mediaType == 'image/png') {
                ext = '.png';
            } else if (link.mediaType == 'text/tsv') {
                ext = '.tsv';
            } else if (link.mediaType == 'text/kml') {
                ext = '.kml';
            } else if (link.mediaType == 'text/xplane') {
                ext = '.fdr';
            }

            return ext;
        }
    }

    angular.module('dg.actions').component('exportInvoker', {
        bindings: {
            query: '<?',
            link: '<',
            fileId: '<?'
        },
        require: {
            formEditor: '^formEditor'
        },
        templateUrl: '/digmo/src/actions/action-invoker.html',
        controller: ExportInvokerController,

    });
}